export default __webpack_public_path__ + "static/media/ISWEC-10.c0e6548f.pdf";